import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { SendToPortalBO, ColumnChangeBO } from './employee.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }



  saveEmployeedata(Employee): Observable<any> {
    let url = "api/Employee/SaveEmployee";
    return this.http.post(url, Employee, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  ///////////////////////////////////////////save payor RequiredId////////////////////////////////////////////////
  savePayorRequired(payor): Observable<number> {
    let url = "api/PayorRequiredID/saveUpdatePayorRequiredId";
    return this.http.post<number>(url, payor, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  //////////////////////////get Payor////////////////////////////////////////////////////////////////
  getpayor(): Observable<[{ Key: string, Value: string }]> {
    let url = "api/PayorRequiredId/GetPayorDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  SaveEmployeePayrate(bo: any): Observable<any> {
    let url = "api/EmployeePayrate/SaveEmployeePayrate";
    return this.http.post(url, bo, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getclient(): Observable<any> {
    let url = "api/EmployeePayrate/GetcliDD?";
    return this.http.get(url, { observe: 'response', responseType: "text" }).pipe(map(data => data.body),
      catchError(this.errorService.handleError));
  }

  deletepayrate(paramsData: URLSearchParams) {
    let url = "api/EmployeePayrate/DeleteEmployeePayrate?"
    return this.http.delete(url + paramsData, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )

  }

  getLov(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Lov/GetLovDropDown?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getServicedropDown(): Observable<any> {
    let url = "api/Service/GetServiceDropdown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetLocationDropDown(): Observable<any> {
    let url = "api/Location/GetLocationDropDown";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  SentToEmployee(MailSend: SendToPortalBO): Observable<any> {
    let url = "api/Employee/SendToEmployeePortal";
    return this.http.post(url, MailSend, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }

  getportalCreateCheck(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Employee/GetEmployeePortal?";
    return this.http.get(url + paramsData, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  savecolumwidth(list: ColumnChangeBO): Observable<any> {
    let url = "api/ColumnChange/Savewidth?";
    return this.http.post<number>(url, list, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //==============================get employee permission==========================================//
  getEmployeepermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  ////////////////////////delete payor required id////////////////////////////////////////////////
  deletepayorReqiured(paramsData: URLSearchParams) {
    let url = "api/PayorRequiredID/DeletePayorRequiredId?"
    return this.http.delete<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )

  }

  getExportCsv(): Observable<any> {
    let url = "api/Employee/GetExployeeExport?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )

  }

  EmployeeLanguageList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Employee/empLanList?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

}
